import { AxiosResponse } from 'axios';
import { api } from './api';

export class RubricaeService {
    public static post(path: string, obj?: Record<string, any>, config?: Record<string, any>): Promise<AxiosResponse> {
        return api.post(path, obj, config);
    }

    public static get(path: string, config?: Record<string, any>): Promise<AxiosResponse> {
        return api.get(path, config);
    }

    public static put(path: string, obj?: Record<string, any>, config?: Record<string, any>): Promise<AxiosResponse> {
        return api.put(path, obj, config);
    }
}
